import {OpenEndedQuestionState} from './classroom/models';

function initialState(): OpenEndedQuestionState {
  return {answer: ''};
}

class OpenEndedQuestionUtilsClass {
  readonly initialState = initialState;
}

export const openEndedQuestionUtils = new OpenEndedQuestionUtilsClass();
